// @ts-ignore esModuleInterop
import React, { useState } from 'react'
// @ts-ignore no types
import _ from 'lodash'
// @ts-ignore no types
import instrument from '@adc/instrument'
import type { primitives } from '@adc/blueprint'
import {
  Button,
  Form,
  RadioGroupField,
  Modal,
  Text,
  Stepper,
  Alert,
  InputField,
  StandardFieldLabel,
  Icon,
  hooks,
  // @ts-ignore no types
} from '@adc/ui-adc'
import * as graph from '@adc/sdk'
import type { FirstLookBuyerSelectionType } from '@adc/sdk/types'
import {
  REGISTER_TO_BID,
  REGISTER_REDIRECT_URL_ACTION,
  REDIRECT_ACTION_KEY,
} from 'common/statics'
import {
  handleSaveProperty,
  handleRegistration as handleReg,
} from 'common/modules/auctionDetails/common'
// @ts-ignore no types
import { connect } from 'react-redux'
import _cx from 'classnames/bind'
import {
  PropertyPageActionsType,
  usePropertyContext,
} from 'common/context/property'
import { useListingContext } from 'common/context/listing'
import { saveFirstLookBuyerSelection } from '../../../common/providers/firstLook'
import { getRegistrationRestrictedValues } from '../../../common/utils/listing'
// @ts-ignore no types
import congratulationsGif from '../../../common/images/congratulation-success-loop-once.gif'
import analytics from '../../services/analytics'
import { withModalHooks } from '../../hooks/useModalFeatures'
// @ts-ignore no types
import cls from './styles.scss'
import {
  radioOptions,
  californiaSpecialTreatmentRadioOptions,
} from './radioOptions'
import { stepsToMakeOffer, stepsToSave, updateCompletedStep } from './steps'

const cx = _cx.bind(cls)

export const REGISTRATION_LIMIT_REACHED = 'REGISTRATION_LIMIT_REACHED'

// source used for analytics, used to support both mao and registration but now just registration
// TODO: remove this and the need for it across all of pdp, but that may require touching a lot of files
const source = () => 'bidderRegistration'
interface FirstLookModalButtonProps {
  user: primitives.AuctionUser
  showFirstLookModal: boolean
  pushAuthQueueItem: (args: any) => void
  pushOnboardingQueueItem: (args: any) => void
  toggleAuthModal: (args: any) => void
  size?: 'large' | 'small' | 'medium' | 'marshmallow' | undefined
  elmId?: string
  text?: string
}

const FirstLookModalButton = ({
  user,
  showFirstLookModal,
  pushAuthQueueItem = () => {},
  pushOnboardingQueueItem = () => {},
  toggleAuthModal = () => {},
  size = 'large',
  elmId = '',
  text = '',
}: FirstLookModalButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [steps, setSteps] = useState(stepsToMakeOffer)
  const [activeStep, setActiveStep] = useState(0)
  const [selection, setSelection] = useState('')
  const [fullName, setFullName] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorResponse, setErrorResponse] = useState(false)

  const { listing, listingActions } = useListingContext()
  const { property, propertyActions } = usePropertyContext()

  const isSaved = property.is_currently_saved
  const initiateRegisterFlow = () => {
    let targetWhenSaved

    if (showFirstLookModal) {
      targetWhenSaved = openModal
    } else {
      // no modal, just got straight through to reg
      targetWhenSaved = handleRegistration
    }

    handleSave(propertyActions?.toggleSaveProperty, targetWhenSaved)
  }

  hooks.useMountEffect(() => {
    if (
      localStorage.getItem(REDIRECT_ACTION_KEY) === REGISTER_REDIRECT_URL_ACTION
    ) {
      initiateRegisterFlow()

      localStorage.removeItem(REDIRECT_ACTION_KEY)
    }
  })

  const openModal = () => {
    analytics.firstLookModal.start()
    setIsModalOpen(true)
  }

  // auto-saves property forcing login if needed
  const handleSave = (
    toggleSaveProperty:
      | PropertyPageActionsType['toggleSaveProperty']
      | undefined,
    callbackWhenDone?: (args?: any) => void
  ) => {
    if (user?.logged_in) {
      autoSaveProperty(toggleSaveProperty)
      callbackWhenDone?.()
    } else {
      pushAuthQueueItem([() => autoSaveProperty(toggleSaveProperty)])
      if (callbackWhenDone) pushOnboardingQueueItem([callbackWhenDone])
      toggleAuthModal('login')
    }
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSteps(stepsToMakeOffer)
    setActiveStep(0)
    setSelection('')
    setFullName('')
    setLoading(false)
    setErrorResponse(false)
  }

  const onOptionChange = (
    _e: any,
    { value }: { value?: FirstLookBuyerSelectionType } = {}
  ) => {
    setSelection(value || '')
    setSteps(
      value === graph.enums.FirstLookBuyerSelectionType.Investor
        ? stepsToSave
        : stepsToMakeOffer
    )
  }

  const onNameInputChange = (e: any) => {
    setFullName(e?.target?.value)
  }

  const autoSaveProperty = (
    toggleSaveProperty?: PropertyPageActionsType['toggleSaveProperty']
  ) => {
    if (!isSaved) {
      return handleSaveProperty({
        listing,
        property,
        saveProperty: toggleSaveProperty,
        source: source(),
      })
    }
  }

  // template version of handleRegistration...
  const handleRegistration = () => {
    handleReg({
      actions: {
        pushAuthQueueItem,
        pushOnboardingQueueItem,
        toggleAuthModal,
      },
      listing,
      user,
      actionSource: 'register-to-bid',
    })()
  }

  const handleBack = () => {
    Boolean(selection) && analytics.firstLookModal.back(selection)
    setActiveStep(activeStep - 1)
  }

  const handleSubmit = () => {
    if (
      activeStep === 0 ||
      selection !== graph.enums.FirstLookBuyerSelectionType.Investor
    ) {
      // Next - always on initial step or other steps when not investor
      setSteps(updateCompletedStep(steps, activeStep, true))
      updateCompletedStep(steps, activeStep, true)
      if (activeStep === 0) {
        Boolean(selection) &&
          analytics.firstLookModal.acknowledgements(selection)
      }

      if (activeStep === 1) {
        setLoading(true)
        // if we're not an investor and going next on second step, submit API call saving buyer selection

        const saveFirstLookSelectionPayload = {
          listing_id: listing?.listing_id || '',
          signature: fullName,
          buyer_selection: selection,
        }
        saveFirstLookBuyerSelection(saveFirstLookSelectionPayload)
          .then(async res => {
            if (!listing?.is_current_user_first_look_qualified) {
              await listingActions?.refresh(listing)
            }

            setLoading(false)
            setActiveStep(activeStep + 1)
            setErrorResponse(Boolean(res.body?.errors))

            instrument.increment('first_look_buyer_selection', 1, [
              `status:${res.body.errors ? 'failure' : 'success'}`,
            ])

            Boolean(selection) && analytics.firstLookModal.complete(selection)
          })
          .catch(_e => {
            setLoading(false)
            setActiveStep(activeStep + 1)
            setErrorResponse(true)
          })
      } else {
        // if not on step === 1, then we're not submitting so can call this always, but if we are, this should only trigger on API response to show congrats or error
        setActiveStep(activeStep + 1)
      }
    } else {
      Boolean(selection) && analytics.firstLookModal.done(selection)

      closeModal()
      // handleSave()
    }
  }

  const getStepKey = () => steps[activeStep]?.key || 0

  const getStepCanProceed = () =>
    steps[activeStep].canProceed({ selection, fullName })

  const renderNonInvestorCompleteStep = () => {
    return errorResponse ? (
      <Form className={cx('center')}>
        <div
          className={cx('flex-center', 'large-space-bottom', 'large-space-top')}
        >
          <Icon
            iconStyle='light'
            name='times-circle'
            color='error'
            size='huge'
          />
        </div>
        <Text.Header className={cx('u-mb-3')} level={2}>
          An unexpected error has occurred.
        </Text.Header>
        <Text size='large' className={cx('large-space-bottom')}>
          We were unable to save your selection. Please try again later.
        </Text>
        <div className={cx('flex-center')}>
          <Button
            className={cx('large-fixed-button')}
            role='primary'
            elmId='error_close_button'
            onClick={closeModal}
          >
            Close
          </Button>
        </div>
      </Form>
    ) : (
      <Form>
        <div className={cx('flex-center')}>
          <img
            height='300px'
            src={congratulationsGif}
            className={cx('u-mb-5')}
          />
        </div>
        <div className={cx('center', 'u-mb-3')}>
          <Text.Header data-elm-id='congratulations-header' level={2}>
            Congratulations!
          </Text.Header>
          <Text size='large' className={cx('large-space-bottom')}>
            You are now allowed to bid on this property.
          </Text>
          <div className={cx('flex-center', 'u-mb-4')}>
            <Button
              role='primary'
              elmId='step3_registration_button'
              className={cx(size === 'large' ? 'large-fixed-button' : '')}
              onClick={handleRegistration}
            >
              {REGISTER_TO_BID}
            </Button>
          </div>

          <a data-elm-id='back_to_pdp_link' onClick={() => closeModal()}>
            Back to Property Details
          </a>
        </div>
      </Form>
    )
  }

  const isCaliforniaSpecialTreatmentRequired = () => {
    const address = property.summary?.address || {}
    const propertyState = _.get(address, 'country_primary_subdivision', '')
    return propertyState === 'California'
  }

  const renderEntityAgreementText = () => {
    return (
      <>
        {isCaliforniaSpecialTreatmentRequired() ? (
          <>
            <br />
            The undersigned hereby represents and declares under the penalty of
            perjury that the prospective purchaser is one of the following:
            <ul className={cx('first-look-special-treatment-agreement-list')}>
              <br />
              <li>
                A nonprofit corporation that meets all of the following
                requirements:
                <ul>
                  <li>
                    The nonprofit corporation has a determination letter from
                    the Internal Revenue Service affirming its tax-exempt status
                    pursuant to Section 501(c)(3) of the Internal Revenue Code
                    and is not a private foundation as that term is defined in
                    Section 509 of the Internal Revenue Code.
                  </li>
                  <li>The nonprofit corporation is based in California. </li>
                  <li>
                    All of the board members of the nonprofit corporation have
                    their primary residence in California.
                  </li>
                  <li>
                    The primary activity of the nonprofit corporation is the
                    development and preservation of affordable rental or home
                    ownership housing in California.
                  </li>
                </ul>
              </li>
              <br />
              <li>
                A community land trust based in California, as defined in clause
                (ii) of subparagraph (C) of paragraph (11) of subdivision (a) of
                Section 402.1 of the Revenue and Taxation Code.
              </li>
              <li>
                A limited-equity housing cooperative, as defined in Section 817,
                that is based in California.{' '}
              </li>
              <li>
                The state, the Regents of the University of California, a
                county, city, district, public authority, or public agency, and
                any other political subdivision or public corporation in the
                state.
              </li>
              <br />
            </ul>
          </>
        ) : (
          <>
            <Text size='large' weight='heavy'>
              I am an employee or buyer's agent representing an entity that is
              one of the following:
            </Text>
            <br />
            <Text weight='normal'>1. A local government entity</Text>
            <Text weight='normal'>2. An approved non-profit</Text>
          </>
        )}
      </>
    )
  }

  const renderOwnerOccupantAgreementText = () => {
    return (
      <>
        {isCaliforniaSpecialTreatmentRequired() ? (
          <>
            <br />
            The undersigned hereby represents and declares under the penalty of
            perjury that they are a natural person that:
            <ul className={cx('first-look-special-treatment-agreement-list')}>
              <br />
              <li>
                Will occupy the property as their primary residence within 60
                days of the trustee’s deed being recorded.
              </li>
              <li>Will maintain their occupancy for at least one year.</li>
              <li>Is not any of the following: </li>
              <ul>
                <li>The mortgagor or trustor. </li>
                <li>
                  The child, spouse, or parent of the mortgagor or trustor.
                </li>
                <li>
                  The grantor of a living trust that was named in the title to
                  the property when the notice of default was recorded.{' '}
                </li>
                <li>
                  An employee, officer, or member of the mortgagor or trustor.
                </li>
                <li>
                  A person with an ownership interest in the mortgagor, unless
                  the mortgagor is a publicly traded company.
                </li>
              </ul>
              <li>
                Is not acting as the agent of any other person or entity in
                purchasing the real property.
              </li>
              <br />
            </ul>
          </>
        ) : (
          <>
            <Text size='large' weight='heavy'>
              I am the buyer purchasing this property or their agent, and agree:
            </Text>
            <br />
            <Text weight='normal'>
              1. The homebuyer will be living in the property as a primary
              residence within 60 days of closing
            </Text>
            <Text weight='normal'>
              2. The homebuyer will not sell or rent the property within one
              year of purchase
            </Text>
          </>
        )}
      </>
    )
  }

  const renderAcknowledgementsAndAgreementStep = () => {
    return (
      <Form>
        <Text.Header level={2}>
          {isCaliforniaSpecialTreatmentRequired()
            ? 'Acknowledgement and Affidavit'
            : 'Acknowledgements'}
        </Text.Header>
        {isCaliforniaSpecialTreatmentRequired() && (
          <Text size='large' weight='heavy'>
            You must read and accept the entire agreement in order to proceed
          </Text>
        )}
        {selection === graph.enums.FirstLookBuyerSelectionType.EntityApproved
          ? renderEntityAgreementText()
          : renderOwnerOccupantAgreementText()}

        <div className={cx('u-mb-5', 'u-mt-5')}>
          {/* @ts-ignore fix types, more of these are optional */}
          <Alert
            header='Please Note'
            content={
              isCaliforniaSpecialTreatmentRequired() // note, this will be inaccurate if we add any other states than CA
                ? "By typing your name below, you certify under penalty of perjury under the laws of the State of California that the prospective purchaser meets the criteria above. Further, any misrepresentation may result in suspension of your account or imposition of damages in accordance with Auction.com's Participation Terms."
                : 'By typing your name, you acknowledge that the buyer meets the criteria above. The buyer will be required to certify this information during the contracting process. Any misrepresentation may result in suspension of your account and/or monetary penalties.'
            }
            role='caution'
            showIcon
          />
        </div>

        <InputField
          name='fullname'
          label={
            <StandardFieldLabel
              label='Type Your Full Name'
              subLabel={
                isCaliforniaSpecialTreatmentRequired()
                  ? 'By typing your name, you are electronically signing the above affidavit and agree that your electronic signature will be enforceable as an original to the same extent as a handwritten signature.'
                  : 'To confirm you have read and acknowledge the above conditions'
              }
            />
          }
          elmId='full_name'
          required
          onChange={onNameInputChange}
          value={fullName}
          maxLength={80}
        />
      </Form>
    )
  }

  const renderContent = () => {
    switch (getStepKey()) {
      case 'basic_information':
        return (
          <Form>
            <Text.Header level={2}>
              Who will purchase this property?
            </Text.Header>
            <RadioGroupField
              label=''
              options={
                isCaliforniaSpecialTreatmentRequired()
                  ? californiaSpecialTreatmentRadioOptions
                  : radioOptions
              }
              elmId='selection'
              name='selection'
              compact={false}
              onChange={onOptionChange}
              value={selection}
            />
          </Form>
        )
      case 'acknowledgements':
        return renderAcknowledgementsAndAgreementStep()
      case 'complete':
        return selection ===
          graph.enums.FirstLookBuyerSelectionType.Investor ? (
          <Form>
            <Text.Header level={2}>I am an Investor.</Text.Header>
            <Text size='large' className={cx('medium-large-space-bottom')}>
              Properties in the First Look Program are only available for
              purchase by investors once the First Look period has expired.
            </Text>
            <Text size='large' className={cx('medium-large-space-bottom')}>
              We will inform you once this property becomes available for
              investors to place bids.
            </Text>
          </Form>
        ) : (
          renderNonInvestorCompleteStep()
        )
      default:
        return <></>
    }
  }

  const accountRestrictedAlertValues = getRegistrationRestrictedValues({
    listing,
    user,
  })

  const role:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'brand'
    | 'navigation'
    | 'navigation-light'
    | undefined = 'primary'

  const buttonProps = {
    elmId: elmId || 'registration_button',
    size,
    text: text || REGISTER_TO_BID,
    role,
    disabled: accountRestrictedAlertValues?.isRegistrationButtonDisabled,
  }

  return (
    <>
      <Button
        {..._.omit(buttonProps, 'text')}
        className={cx(size === 'large' ? 'large-fixed-button' : '')}
        onClick={initiateRegisterFlow}
      >
        {buttonProps.text}
      </Button>
      <Modal
        className={cx('modal')}
        elmId='make_offer_modal'
        open={isModalOpen}
        mobileTitleSkin='light'
        onClose={closeModal}
        size='small'
        closeIcon={null}
        closeOnDimmerClick={false}
        title={
          <Stepper steps={steps} activeStep={activeStep} elmId='stepper' />
        }
      >
        <Modal.Content scrolling>
          <div className={cx('content-wrapper')}>{renderContent()}</div>
        </Modal.Content>
        {activeStep < 2 && (
          <Modal.Actions className={cx('actions')}>
            <Button
              role='secondary'
              elmId='back_button'
              onClick={handleBack}
              className={cx({ hidden: activeStep === 0 })}
            >
              Back
            </Button>
            <div>
              <Button
                className={cx('cancel-button', {
                  hidden: activeStep !== 0,
                })}
                role='secondary'
                elmId='close_button'
                onClick={closeModal}
              >
                Cancel
              </Button>
              <Button
                role='primary'
                elmId='confirm_button'
                onClick={handleSubmit}
                disabled={!getStepCanProceed()}
                loading={loading}
              >
                {selection ===
                  graph.enums.FirstLookBuyerSelectionType.Investor &&
                activeStep === 1
                  ? 'Done'
                  : 'Next'}
              </Button>
            </div>
          </Modal.Actions>
        )}
      </Modal>
    </>
  )
}

const mapStateToProps = (store: any) => {
  const { listing } = store
  const showFirstLookModal =
    Boolean(listing.listing_configuration?.is_first_look_enabled) &&
    Boolean(!listing.is_current_user_first_look_qualified)

  return {
    user: store.user,
    featureFlags: store.featureFlags,
    showFirstLookModal,
  }
}

const mergeProps = (stateProps: any, dispatchProps = {}, ownProps: any) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

export default connect(
  mapStateToProps,
  null,
  mergeProps
)(withModalHooks(FirstLookModalButton))
